import { createContext, useContext } from 'react';

export enum EDictionaryScope {
  form = 'form',
  search = 'search',
}

export const DictionaryScopeContext = createContext<EDictionaryScope>(EDictionaryScope.form);

export const useDictionaryScope = (): EDictionaryScope => useContext(DictionaryScopeContext);
